import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

// Mirrors proposed UI: each portal page passes (title, crumbs) into PORTAL.mount()
const ROUTE_META: Record<string, { title: string; crumbs: string }> = {
  "/reviewer/overview": { title: "Dashboard", crumbs: "Reviewer" },
  "/reviewer/dashboard": { title: "Charts", crumbs: "Reviewer · Monitoring" },
  "/reviewer/reports": { title: "Reports", crumbs: "Reviewer · Monitoring" },
  "/admin/project-setup": { title: "Project Setup", crumbs: "Admin · Manage" },
  "/admin/activities": { title: "Activities", crumbs: "Admin · Manage" },
};

const AppShell: React.FC = () => {
  const location = useLocation();
  const meta = ROUTE_META[location.pathname] || {
    title: "HSP Monitoring",
    crumbs: "",
  };

  return (
    <div className="app">
      <Sidebar />
      <main className="main">
        <TopBar title={meta.title} crumbs={meta.crumbs} />
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AppShell;
